import Types from '../../action/types'

const defaultState = {
	files: [],
	preUploadFile: null,
	currFile: null,
	uploadAgainFile: null
}

export default function onAction(state=defaultState, action){
	switch (action.type) {
    case Types.FILES_CHANGE:
			return {
				...state,
				files: action.files
			}
		case Types.PREUPLOADFILE_CHANGE:
			return {
				...state,
				preUploadFile: action.preUploadFile
			}
		case Types.CURRFILE_CHANGE:
			return {
				...state,
				currFile: action.currFile
			}
		case Types.UPLOADAGAINFILE_CHANGE:
			return {
				...state,
				uploadAgainFile: action.uploadAgainFile
			}
		default:
			return state
	}
}
